const archetypePhraseMapping = {
  surveillance: 'archetypeSurveillanceOfficer',
  tech_ops: 'archetypeTechOpsOfficer',
  special_forces: 'archetypeSpecialOps',
  agent_handler: 'archetypeAgentHandler',
  hacker: 'archetypeHacker',
  intelligence_operative: 'archetypeIntelOperative',
  intelligence_analyst: 'archetypeAnalyst',
  counter_intelligence_investigator: 'archetypeSpycatcher',
  cryptologist: 'archetypeCryptologist',
  spymaster: 'archetypeSpymaster',
};

const getArchetypeLabel = (phrases, id) => phrases[archetypePhraseMapping[id]];
const getLinkPath = (path, id) => `${path}${id}`.replace('_', '-');

const selectArchetypeMatchesChartData = (phrases, data, linkPath) => (
  data.map(({ id, percentage }) => ({
    value: percentage,
    label: getArchetypeLabel(phrases, id),
    link: getLinkPath(linkPath, id),
  }))
);

export default selectArchetypeMatchesChartData;
